/* unplugin-vue-components disabled */import { render } from "./E808D2AnswerBtn.vue?vue&type=template&id=9e59318a&scoped=true"
import script from "./E808D2AnswerBtn.vue?vue&type=script&lang=js"
export * from "./E808D2AnswerBtn.vue?vue&type=script&lang=js"

import "./E808D2AnswerBtn.vue?vue&type=style&index=0&id=9e59318a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9e59318a"]])

export default __exports__